import React from 'react';
import { CircleCheck, ShieldCheck, CalendarCheck, ArrowRight, Zap } from 'lucide-react';
import { processSteps } from '../../data/mock';

const iconMap = {
  MessageCircleCheck: CircleCheck,
  ShieldCheck,
  CalendarCheck
};

const ProcessSection = () => {
  return (
    <section className="py-20 md:py-28 px-4 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23007AFF' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
      
      <div className="relative max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-emerald-50 to-green-50 text-emerald-600 text-sm font-semibold mb-6 border border-emerald-100 shadow-sm">
            <Zap className="w-4 h-4" />
            Protocolo Probado
          </div>
          <h2 className="md:text-4xl !font-bold !text-4xl mb-4 text-gray-900">
            Así funciona el Protocolo Omnicanal
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Un sistema inteligente que trabaja 24/7 para blindar tu agenda
          </p>
        </div>

        {/* Steps Container */}
        <div className="relative">
          {/* Connection Line (Desktop) */}
          <div className="hidden md:block absolute top-24 left-[20%] right-[20%] h-1 bg-gradient-to-r from-[#25D366] via-[#007AFF] to-[#007AFF] rounded-full z-0">
            <div className="absolute inset-0 bg-gradient-to-r from-[#25D366] via-[#007AFF] to-[#007AFF] rounded-full animate-pulse opacity-50"></div>
          </div>

          {/* Steps Grid */}
          <div className="grid md:grid-cols-3 gap-8 md:gap-6 relative z-10">
            {processSteps.map((step, index) => {
              const IconComponent = iconMap[step.icon];
              const isWhatsApp = index === 0;
              const primaryColor = isWhatsApp ? '#25D366' : '#007AFF';
              const bgGradient = isWhatsApp ?
              'from-green-50 to-emerald-50' :
              'from-blue-50 to-indigo-50';

              return (
                <div key={step.id} className="relative">
                  <div className={`bg-gradient-to-br ${bgGradient} rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-white group hover:-translate-y-2`}>
                    {/* Step Number */}
                    <div className="absolute -top-4 -left-2 w-12 h-12 rounded-2xl bg-gray-900 text-white flex items-center justify-center font-bold shadow-xl transform -rotate-3 group-hover:rotate-0 transition-transform">
                      {step.id}
                    </div>

                    {/* Icon Container */}
                    <div className={`w-20 h-20 rounded-2xl bg-white flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="w-10 h-10" style={{ color: primaryColor }} />
                    </div>

                    {/* Badge */}
                    <div
                      className="inline-block px-4 py-1.5 rounded-full text-xs font-bold mb-4 shadow-sm"
                      style={{
                        backgroundColor: `${primaryColor}15`,
                        color: primaryColor,
                        border: `1px solid ${primaryColor}30`
                      }}>

                      {step.subtitle}
                    </div>
                    
                    {/* Content */}
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>

                    {/* Arrow for mobile */}
                    {index < processSteps.length - 1 &&
                    <div className="md:hidden flex justify-center mt-6">
                        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                          <ArrowRight className="w-5 h-5 text-gray-400 rotate-90" />
                        </div>
                      </div>
                    }
                  </div>
                </div>);

            })}
          </div>
        </div>

        {/* Bottom Message */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-gray-900 text-white shadow-xl">
            <Zap className="w-5 h-5 text-amber-400" />
            <span className="!font-medium !text-base">Todo automatizado. Sin intervención manual. Sin estrés.</span>
          </div>
        </div>
      </div>
    </section>);

};

export default ProcessSection;